<script setup lang="ts">
import { useCounterStore } from "@/stores/counter";
import { useMemberService } from "@/stores/memberFunction/memberService";
import v from "@image/memberFunction/07/v.png";
import v_bg from "@image/memberFunction/07/v_bg.png";
import 會員選擇無 from "@image/memberFunction/common/會員選擇無.png";
import 會員選擇 from "@image/memberFunction/common/會員選擇.png";
import { ref, onMounted } from "vue";

const store = useCounterStore();

const rules = ref('');
const memberService = useMemberService();
const agreeRegister = ref(false);

// 送出同意條款
const submitAgree = async () => {
  if (!agreeRegister.value) return;
  // 如果沒有勾選同意條款, 不執行後續動作
  try {
    await memberService.updateUserTerms();
  } catch (error) {
    console.log(error)
  } finally {
    // 不管成功或失敗都關閉, 避免使用者卡住導致體驗變差
    store.closeUserTermModal();
  }
};

onMounted(async () => {
  const data = await memberService.getGameRule();
  if (data) {
    rules.value = data.sContent;
  }
});
</script>

<template>
  <div class="fixed top-0 left-0 w-full h-full flex">
    <div class="m-auto">
      <div
        class="max-w-[460px] w-[95vw] bg-white h-[50px] rounded-t-[8px] flex justify-center items-center bg-linear-agree-register-title z-50 text-[26px] font-bold">
        {{
          $t("Context.UserTerm.Title")
        }}
      </div>
      <div class="max-w-[460px] w-[95vw] h-[60dvh] lg:h-[70dvh] overflow-y-auto bg-white">
        <div class="p-[12px] w-full top-0 text-black flex flex-col items-center bg-white text-[20px] text-justify"
          v-html="rules"></div>
      </div>
      <div class="max-w-[460px] w-[95vw] p-[12px] bg-white">
        <div class="w-full max-w-[1190px] mx-auto flex justify-between items-center">
          <label for="agreeRegister" class="w-fit flex items-center cursor-pointer">
            <div class="relative">
              <img class="w-[25px]" :src="v_bg" alt="" />
              <img :src="v" alt="" class="absolute top-[40%] -translate-y-1/2 left-[60%] -translate-x-1/2"
                v-if="agreeRegister" />
            </div>
            <VField name="agreeRegister" id="agreeRegister" type="checkbox" class="hidden" :rules="{ required: true }"
              v-model="agreeRegister" />
            <span class="hover:text-primary/80 text-black text-[16px]">{{
              $t("Context.UserTerm.Terms") }}</span>
          </label>
          <button @click="submitAgree" :disabled="!agreeRegister" class="relative flex justify-center items-center"
            :class="{
              'text-secondary': agreeRegister,
              'text-primary': !agreeRegister,
            }">
            <img :src="會員選擇無" alt="" v-show="!agreeRegister" />
            <img :src="會員選擇" alt="" v-show="agreeRegister" />
            <div class="absolute text-[20px] font-bold">
              {{ $t("Context.UserTerm.Button") }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.bg-linear-agree-register-title {
  background: linear-gradient(#a7bd45, #608530);
}
</style>
